import cachedFirestore from "./cachedFirestore";
import { getLogger } from "./logging";
import { FirebaseFirestore } from "./plugins";
import store from "./store";

const log = getLogger("SnapshotListeners");

const addProfileDocumentSnapshotListener = async () => {
  if (!store.user.uid) {
    log.info("User not logged in");
    return;
  }
  const { refreshProfile } = await require("./profile");
  await FirebaseFirestore.addDocumentSnapshotListener(
    {
      reference: `profile/${store.user.uid}`,
    },
    (event, error) => {
      if (error) {
        log.error(error);
      } else {
        const {
            levelsWonCount,
          levelsCreatedCount,
          lastPostedLevelAt,
          followingCount,
          followersCount,
        } = event.snapshot.data || {};
        store.profile.levelsWonCount = levelsWonCount;
        store.profile.levelsCreatedCount = levelsCreatedCount;
        store.profile.lastPostedLevelAt = lastPostedLevelAt;
        store.profile.followingCount = followingCount;
        store.profile.followersCount = followersCount;
        store.save("profile");
        cachedFirestore.clearCacheForDocumentsInCollection("profile");
        cachedFirestore.clearCollectionCache(
          `profile/${store.user.uid}/following`
        );
        refreshProfile();
      }
    }
  );
};

export const addDocumentSnapshotListeners = async () => {
  await FirebaseFirestore.removeAllListeners();
  await Promise.all([addProfileDocumentSnapshotListener()]);
};
